export default __webpack_public_path__ + "static/media/lawenda_cien.00d072e4.svg";